import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { wait } from "@testing-library/user-event/dist/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function Withdrawal_Payment_Reports_Usdt() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [dataOutput, setdataOutput] = useState([]);
  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait..."
  );

  const [Uid, setUid] = useState(null);
  const [uplineId, setuplineId] = useState(null);
  const [fdate, setfdate] = useState("");
  const [Tdate, setTdate] = useState("");

  let mainAccount = "";

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/PaidWithdrawalListUsdt",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          Fdate: fdate,
          Tdate: Tdate,
          status: 2,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.clear();
      console.log("responceRight?.data?.data-->", responceRight?.data?.data);
      setdataOutput(responceRight?.data.dataOut);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let array = [];
      responceRight.forEach((item, index) => {
        array.push({
          sr: index + 1,
          id: item.id,
          uid: item.uid,
          address: item.wallet,
          accountnumber: item.accountnumber,
          bank_name: item.bank_name,
          branch: item.branch,
          holder: item.holder,
          ifsc: item.ifsc,
          Request_amount: item.Request_amount,
          adminCharge: item.admincharge,
          paidamount: item.paidamount,
          req_date: item.req_date,
          approve_date: item.approve_date,
          cancel_date: item.cancel_date,
          status: item.status,
          remark: item.remark,
          cancelremark: `${item.status == "Rejected" ? item.txn : ""}`,
          txn: (
            <>
              <a href={`https://bscscan.com/tx/${item.txn}`} target="_blank">
                {" "}
                View TXN
              </a>
            </>
          ),
        });
        setleftreferralApi(array);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PaidWithdrawalListUsdt",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          Fdate: fdate,
          Tdate: Tdate,
          status: 2,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight?.data?.data?.[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: item.id,
          UserID: item.uid,
          Address: item.wallet,
          //accountnumber: item.accountnumber,
          //bank_name: item.bank_name,
          //branch: item.branch,
          //holder: item.holder,
          //ifsc: item.ifsc,
          Request_Amount: item.Request_amount,
          Admin_Charge: item.admincharge,
          Paid_Amount: item.paidamount,
          Req_Date: item.req_date,
          Approve_Date: item.approve_date,
          Cancel_Date: item.cancel_date,
          Status: item.status,
          Remark: item.remark,
          TXN: item.txn,
        });
      });

      const fileName = "PaidWithdrawal";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Wallet Address", accessor: "address" },
      { Header: "Requested Amount", accessor: "Request_amount" },
      { Header: "Admin Charge", accessor: "adminCharge" },
      { Header: "Withdrawal", accessor: "paidamount" },
      { Header: "Requested Date", accessor: "req_date" },
      //{ Header: "Holder Name", accessor: "holder" },
      //{ Header: "Account Number", accessor: "accountnumber" },
      //{ Header: "Ifsc", accessor: "ifsc" },
      //{ Header: "Bank Name", accessor: "bank_name" },
      //{ Header: "Branch", accessor: "branch" },

      { Header: "Paid Date", accessor: "approve_date" },
      { Header: "Cancel Remark", accessor: "cancelremark" },
      { Header: "Cancel Date", accessor: "cancel_date" },
      { Header: "Status", accessor: "status" },
      { Header: "Remark", accessor: "remark" },
      { Header: "Txn", accessor: "txn" },
    ],
  });
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">USDT Paid Withdrawal Report</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UplineId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTdate(e.target.value)}
                        id="Tdate"
                        name="Tdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-1">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 ">
                      <p>
                        {/* Total Requested Amount (USDT) : {dataOutput?.TotalUsd}
                        <br /> */}
                        Total Withdrawal :{dataOutput?.TotalWithdrawlUsd}
                      </p>{" "}
                    </div>
                  </div>
                  {isLoading ? (
                    <Spinner />
                  ) : (
                    <div className="col-md-12">
                      <Table data={currentPostleft} columns={my_team.cols} />

                      <Table_Buttons
                        indexOfFirstPage={indexOfFirstPage}
                        indexOfLastPost={indexOfLastPost}
                        setcurrentPage={setcurrentPage}
                        currentPage={currentPage}
                        totalData={leftreferralApi.length}
                        listPerpage={listPerpage}
                        handleRowsPerPageChange={setlistPerpage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdrawal_Payment_Reports_Usdt;
